const YearZeroActionTypes = {
  SET_YEAR_0_SUBJECTS: 'SET_YEAR_0_SUBJECTS',
};

export default YearZeroActionTypes;
